export default __webpack_public_path__ + "static/media/step-4.d6316948.d6316948.jpg";